import React, { useEffect, useState } from 'react';
import ToggleSwitch from '../../common/ToggleSwitch';
import Pagination from '../../common/Pagination';
import AddEditInsurer from './AddEditInsurer';
import { updateInsurerStatus } from '../../store/slices/Insurer';
import { toast } from 'react-toastify';
import * as HELPER from '../../config/helper';
import { ROLE_FEATURES, STATUS_SUCCESS } from '@src/config/constant';
import { useLanguage } from '@src/context/LanguageContext';

type SelectedPartnerType = {
    id: number,
    name: string,
    partner_name: string,
    admin_fee: string,
    logo: string
}


export default function InsurerListTable(props: any): ReturnType<React.FC> {
    let { apiResponse, partnerListDropDown, loading } = props
    let [showEditInsPartnerIcon, setShowEditInsPartnerIcon] = useState<boolean>(false)
    let [tableData, setTableData] = useState<any[]>([])
    let [paginationData, setPaginationData] = useState<{ total?: number }>({})
    let [selectedPartner, setSelectedPartner] = useState<SelectedPartnerType>({ id: 0, name: '',partner_name:'',admin_fee:'',logo:'' })
    const { translations } = useLanguage();
    
    let totalLengthWithoutPagination = 0
    let page = 1

    const showModalEditInsurance = () => {
        setShowEditInsPartnerIcon(true)
    }

    const hideModalEditInsurance = () => {
        setSelectedPartner({ id: 0, name: '',partner_name:'',admin_fee:'',logo:'' })
        setShowEditInsPartnerIcon(false)
    }

    const handleEditBtnClick = (item: any) => {
        setSelectedPartner(item)
        showModalEditInsurance()
    }

    const handleRequestData = (params: any) => {
        let apiParams = {
            page_number: params.page_no
        }

        props.getInsurerListData(apiParams)

    }

    const handleToggleSwitch = async (element: { id?: number, status: number }) => {
        props.handleLoader(true)

        let apiParams = {
            insurer_id: element.id,
            status: element.status === 1 ? 2 : 1
        }
        const updateMapping: any = await updateInsurerStatus(apiParams)
        if (updateMapping && updateMapping.status === STATUS_SUCCESS) {
           var reResponse = await props.getInsurerListData(apiParams)
            toast.success(updateMapping.message)
            if (apiResponse && apiResponse.data) {
                let response = apiResponse.data
                for (let data of response) {
                    if (data.partner_id === apiParams.insurer_id) {
                        data['status'] = apiParams.status
                    }
                }
                setTableData(response)
            }
        }
        if(reResponse){
            props.handleLoader(false)
        }

    }

    useEffect(() => {
        if (apiResponse) {
            let { data, pagination } = apiResponse || {}
            setTableData(data ?? [])
            setPaginationData(pagination ?? {})
        }
    }, [apiResponse])

    const runPaginationFunc = () => { };

    const updateSelectedPartner = (params:any) => {
        tableData = tableData.map((partner:any)=> (+partner.id === +params.id) ? params : partner);
        setTableData(tableData ?? []);
    }

    return (
        <div>
            <div className="financer-table-list">

                <table>
                    <thead>
                        <tr>
                            <th>{translations.Insurer?.['id'] || translations.commonMsg?.loading}</th>
                            <th>{translations.Insurer?.['Insurer Name'] || translations.commonMsg?.loading}</th>
                            <th>{translations.Insurer?.['Insurer Partner Name'] || translations.commonMsg?.loading}</th>
                            <th>{translations.Insurer?.['Logo'] || translations.commonMsg?.loading}</th>
                            <th>{translations.commonMsg?.['status'] || translations.commonMsg?.loading}</th>
                            <th>{translations.commonMsg?.['action'] || translations.commonMsg?.loading}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData && tableData.map((element: any , indx) => {

                            return (
                                <tr key={indx}>
                                    <td>{element.id}</td>
                                    <td>{element.name}</td>
                                    <td>{element?.partner_list.map((item: any) => item.label).join(', ') }</td>
                                    <td><img 
                                        src= {
                                        element.logo ?? '/images/noimage.svg'} 
                                        onError={(e) => {
                                        const target = e.currentTarget;
                                            target.onerror = null;
                                            target.src = "/images/noimage.svg";
                                        }} 
                                        alt='partner_logo' 
                                        className="ins-img" /></td>
                                    <td>
                                        <div className="on-off-switch">
                                            <ToggleSwitch disabled={!HELPER.isUserHasAccessPage({permissionID: ROLE_FEATURES['insurance_insurer_management'], accessType: 'edit'})} checked={element.status === 1 ? true : false} onChange={() => handleToggleSwitch(element)} />
                                        </div>
                                    </td>
                                    <td>
                                        <ul className='ulaction-btn'>
                                            <li title="Edit" onClick={() => { handleEditBtnClick(element) }}>
                                                <i className='ic-createmode_editedit' style={{ cursor: 'pointer' }}></i>
                                            </li>
                                        </ul>
                                    </td>

                                </tr>)
                        })}

                    </tbody>
                </table>

                <div className="pagination-outer">
                    {paginationData && paginationData.total ? <Pagination
                        paginateData={{
                            page,
                            runPaginationFunc,
                            loading,
                            tableData: props.getInsurerListData,
                            totalLengthWithoutPagination,
                            paginationData,
                            filteredData: props.searchFilters
                        }}
                        sendRequestDataToParent={handleRequestData}
                    /> : ''}
                </div>

            </div>

            <AddEditInsurer callFrom={'EditInsurer'} showAddInsPartnerIcon={showEditInsPartnerIcon} handleModalClose={hideModalEditInsurance} partnerListDropDown={partnerListDropDown} selectedPartner={selectedPartner} fetchPartnerMappings={props.getInsurerListData} handleLoader={props.handleLoader} updateSelectedPartner={updateSelectedPartner}/>

        </div>
    )
}